<template>
  <el-container   style="display: block;">

	<el-container class="lables">

		<el-row  class="la-list1">
		  <el-row>
		    <el-row :span="2" style="margin-top: 30px;margin-bottom: 20px;">
		        <el-input v-model="appid1" style="width: 250px;" placeholder="空间模块APPID"></el-input>
		        <el-input v-model="urls" style="width: 250px;" placeholder="空间模块链接"></el-input>
		
		        <el-button type="primary" style="background-color: #409eff;" @click="add1()" round>添加</el-button>
		    </el-row>
		    <template>
		      <el-table
		    	:data="list"
		      height="500"
		    	border
		    	style="width: 100%;margin-left: 0;height: 800px;text-align: center;">
		      <el-table-column
		
		        width="340"
		        label="空间模块APPID"
		         >
		         <template slot-scope="scope">
		             <div @click="change(scope.row.id,scope.row.appid,1,1)">{{scope.row.appid}}</div>
		         </template>
		      </el-table-column>
          <el-table-column
          
            width="80"
            label="小框化比例"
             >
             <template slot-scope="scope">
                 <div @click="change(scope.row.id,scope.row.xiaokuang,31,1)">{{scope.row.xiaokuang}}</div>
             </template>
          </el-table-column>
		
		      <el-table-column
		
		        width="200"
		        label="空间模块链接"
		         >
		         <template slot-scope="scope">
		           <div @click="change(scope.row.id,scope.row.url,2,1)">{{scope.row.url}}</div>
		         </template>
		      </el-table-column>
		      <el-table-column
		
		        width="200"
		        label="所属平行宇宙"
		         >
		         <template slot-scope="scope">
		           <div @click="change(scope.row.id,scope.row.pingxing,3,1)">{{scope.row.pingxing}}</div>
		         </template>
		      </el-table-column>
		      <el-table-column
		
		        width="200"
		        label="空间模块坐标"
		         >
		         <template slot-scope="scope">
		           <div @click="change(scope.row.id,scope.row.kjzuobiao,4,1)">{{scope.row.kjzuobiao}}</div>
		         </template>
		      </el-table-column>
		      <el-table-column
		        width="80"
		        label="元素点上限"
		        style="font-weight:bold;"
		         >
		         <template slot-scope="scope">
		             <div  @click="change(scope.row.id,scope.row.yuansushangxian,5,1)">{{scope.row.yuansushangxian}}</div>
		
		         </template>
		      </el-table-column>
		
		      <el-table-column label="通用" style="text-align: center;">
		        <el-table-column
		          width="50"
		          label="倍数"
		           >
		           <template slot-scope="scope">
		               <div  @click="change(scope.row.id,scope.row.tongyong,6,1)">{{scope.row.tongyong}}</div>
		           </template>
		        </el-table-column>
		        <el-table-column
		          width="50"
		          label="上限"
		           >
		           <template slot-scope="scope">
		               <div  @click="change(scope.row.id,scope.row.tongyongs,7,1)">{{scope.row.tongyongs}}</div>
		           </template>
		        </el-table-column>
		       </el-table-column>
		       <el-table-column label="精准" style="text-align: center;">
		         <el-table-column
		           width="50"
		           label="倍数"
		            >
		            <template slot-scope="scope">
		                <div  @click="change(scope.row.id,scope.row.jingzhun,8,1)">{{scope.row.jingzhun}}</div>
		            </template>
		         </el-table-column>
		         <el-table-column
		           width="50"
		           label="上限"
		            >
		            <template slot-scope="scope">
		                <div  @click="change(scope.row.id,scope.row.jingzhuns,9,1)">{{scope.row.jingzhuns}}</div>
		            </template>
		         </el-table-column>
		        </el-table-column>
		        <el-table-column label="内部" style="text-align: center;">
		          <el-table-column
		            width="50"
		            label="倍数"
		             >
		             <template slot-scope="scope">
		                 <div  @click="change(scope.row.id,scope.row.neibu,10,1)">{{scope.row.neibu}}</div>
		             </template>
		          </el-table-column>
		          <el-table-column
		            width="50"
		            label="上限"
		             >
		             <template slot-scope="scope">
		                 <div  @click="change(scope.row.id,scope.row.neibus,11,1)">{{scope.row.neibus}}</div>
		             </template>
		          </el-table-column>
		         </el-table-column>
		      <el-table-column label="标识" style="text-align: center;">
		        <el-table-column
		          width="50"
		          label="倍数"
		           >
		           <template slot-scope="scope">
		               <div  @click="change(scope.row.id,scope.row.biaoshi,12,1)">{{scope.row.biaoshi}}</div>
		           </template>
		        </el-table-column>
		        <el-table-column
		          width="50"
		          label="上限"
		           >
		           <template slot-scope="scope">
		               <div  @click="change(scope.row.id,scope.row.biaoshis,13,1)">{{scope.row.biaoshis}}</div>
		           </template>
		        </el-table-column>
		       </el-table-column>
		      <el-table-column label="一般" style="text-align: center;">
		        <el-table-column
		          width="50"
		          label="倍数"
		           >
		           <template slot-scope="scope">
		               <div  @click="change(scope.row.id,scope.row.yiban,14,1)">{{scope.row.yiban}}</div>
		           </template>
		        </el-table-column>
		        <el-table-column
		          width="50"
		          label="上限"
		           >
		           <template slot-scope="scope">
		               <div  @click="change(scope.row.id,scope.row.yibans,15,1)">{{scope.row.yibans}}</div>
		           </template>
		        </el-table-column>
		       </el-table-column>
		      <el-table-column label="地区" style="text-align: center;">
		        <el-table-column
		          width="50"
		          label="倍数"
		           >
		           <template slot-scope="scope">
		               <div  @click="change(scope.row.id,scope.row.diqu,16,1)">{{scope.row.diqu}}</div>
		           </template>
		        </el-table-column>
		        <el-table-column
		          width="50"
		          label="上限"
		           >
		           <template slot-scope="scope">
		               <div  @click="change(scope.row.id,scope.row.diqus,17,1)">{{scope.row.diqus}}</div>
		           </template>
		        </el-table-column>
		       </el-table-column>
		      <el-table-column label="点线(坐标)" style="text-align: center;">
		        <el-table-column
		          width="50"
		          label="倍数"
		           >
		           <template slot-scope="scope">
		               <div  @click="change(scope.row.id,scope.row.dianxianzb,18,1)">{{scope.row.dianxianzb}}</div>
		           </template>
		        </el-table-column>
		        <el-table-column
		          width="50"
		          label="上限"
		           >
		           <template slot-scope="scope">
		               <div  @click="change(scope.row.id,scope.row.dianxianzbs,19,1)">{{scope.row.dianxianzbs}}</div>
		           </template>
		        </el-table-column>
		       </el-table-column>
		      <el-table-column label="点线(设备)" style="text-align: center;">
		        <el-table-column
		          width="50"
		          label="倍数"
		           >
		           <template slot-scope="scope">
		               <div  @click="change(scope.row.id,scope.row.dianxiansb,20,1)">{{scope.row.dianxiansb}}</div>
		           </template>
		        </el-table-column>
		        <el-table-column
		          width="50"
		          label="上限"
		           >
		           <template slot-scope="scope">
		               <div  @click="change(scope.row.id,scope.row.dianxiansbs,21,1)">{{scope.row.dianxiansbs}}</div>
		           </template>
		        </el-table-column>
		       </el-table-column>
		      <el-table-column label="突发" style="text-align: center;">
		        <el-table-column
		          width="50"
		          label="倍数"
		           >
		           <template slot-scope="scope">
		               <div  @click="change(scope.row.id,scope.row.tufa,22,1)">{{scope.row.tufa}}</div>
		           </template>
		        </el-table-column>
		        <el-table-column
		          width="50"
		          label="上限"
		           >
		           <template slot-scope="scope">
		               <div  @click="change(scope.row.id,scope.row.tufas,23,1)">{{scope.row.tufas}}</div>
		           </template>
		        </el-table-column>
		       </el-table-column>
		      <el-table-column label="指向" style="text-align: center;">
		        <el-table-column
		          width="50"
		          label="倍数"
		           >
		           <template slot-scope="scope">
		               <div  @click="change(scope.row.id,scope.row.yuansubeishu,24,1)">{{scope.row.yuansubeishu}}</div>
		           </template>
		        </el-table-column>
		        <el-table-column
		          width="50"
		          label="上限"
		           >
		           <template slot-scope="scope">
		               <div  @click="change(scope.row.id,scope.row.yuansubeishus,25,1)">{{scope.row.yuansubeishus}}</div>
		           </template>
		        </el-table-column>
		       </el-table-column>
		       <el-table-column
		
		        label="连接"
		         >
		         <el-table-column
		           width="50"
		           label="倍数"
		            >
		            <template slot-scope="scope">
		                <div  @click="change(scope.row.id,scope.row.lxbeishu,26,1)">{{scope.row.lxbeishu}}</div>
		
		
		            </template>
		         </el-table-column>
		         <el-table-column
		           width="50"
		           label="上限"
		            >
		            <template slot-scope="scope">
		                <div  @click="change(scope.row.id,scope.row.lxbeishus,27,1)">{{scope.row.lxbeishus}}</div>
		
		
		            </template>
		         </el-table-column>
		
		      </el-table-column>
		      <el-table-column
		
		        label="飞行"
		         >
		         <el-table-column
		           width="50"
		           label="倍数"
		            >
		            <template slot-scope="scope">
		                <div  @click="change(scope.row.id,scope.row.fxbeishu,28,1)">{{scope.row.fxbeishu}}</div>
		
		
		            </template>
		         </el-table-column>
		         <el-table-column
		           width="50"
		           label="上限"
		            >
		            <template slot-scope="scope">
		                <div  @click="change(scope.row.id,scope.row.fxbeishus,29,1)">{{scope.row.fxbeishus}}</div>
		
		
		            </template>
		         </el-table-column>
		
		      </el-table-column>
		      <el-table-column
		        width="100"
		        label="尺寸比例"
		         >
		         <template slot-scope="scope">
		             <div  @click="change(scope.row.id,scope.row.chicunbili,30,1)">{{scope.row.chicunbili}}</div>
		
		         </template>
		      </el-table-column>
		
		      <el-table-column
		
		        width="200"
		        label="操作"
		         >
		         <template slot-scope="scope">
		           <el-row>
		             <el-col :span="8" style="text-align: center;margin-top: 15px;" @click.native="del1(scope.row.id)">删除</el-col>
		             <el-col :span="4" style="text-align: center;margin-top: 15px;margin-left: 30px;" @click.native="chose(scope.row.id,scope.row.appid)">查看</el-col>
		             <!-- <el-col :span="4" style="text-align: center;margin-top: 15px;">更新</el-col> -->
		           </el-row>
		         </template>
		      </el-table-column>
		
		      </el-table>
		    </template>
		  </el-row>
		
		  <el-row>
		    <el-row :span="2" style="margin-top: 30px;">
		        <el-input v-model="appid2" style="width: 250px;" placeholder="APPID"></el-input>
		        <el-input v-model="content" style="width: 250px;" placeholder="起始指令"></el-input>
		
		        <el-button type="primary" style="background-color: #409eff;" @click="add2()" round>添加</el-button>
		    </el-row>
		    <el-row :span="2" style="text-align: center;font-size: 25px;">
		        当前选择:{{name}}
		    </el-row>
		    <template>
		      <el-table
		    	:data="list2"
		      height="600"
		    	border
		    	style="width: 100%;margin-left: 0;height: 800px;text-align: center;">
		      <el-table-column
		
		        width="500"
		        label="APPID"
		         >
		         <template slot-scope="scope">
		             <div @click="change(scope.row.id,scope.row.appid,1,2)">{{scope.row.appid}}</div>
		         </template>
		      </el-table-column>
		
		      <el-table-column
		
		        width="1200"
		        label="起始指令"
		         >
		         <template slot-scope="scope">
		           <div @click="change(scope.row.id,scope.row.content,2,2)">{{scope.row.content}}</div>
		         </template>
		      </el-table-column>
		
		      <el-table-column
		
		        width="200"
		        label="操作"
		         >
		         <template slot-scope="scope">
		           <el-row>
		             <el-col :span="4" style="text-align: center;margin-top: 15px;" @click.native="del2(scope.row.id)">删除</el-col>
		             <!-- <el-col :span="4" style="text-align: center;margin-top: 15px;">更新</el-col> -->
		           </el-row>
		         </template>
		      </el-table-column>
		
		      </el-table>
		    </template>
		  </el-row>
		
		</el-row>

	</el-container>
  <el-dialog
    title="确认删除"
    :visible.sync="disDel1"
    width="30%"
    center>
    <span slot="footer" class="dialog-footer">
  	<el-button @click="disDel1 = false">取 消</el-button>
  	<el-button type="primary" @click="doDel1()">确 定</el-button>
    </span>
  </el-dialog>
  <el-dialog
    title="确认删除"
    :visible.sync="disDel2"
    width="30%"
    center>
    <span slot="footer" class="dialog-footer">
  	<el-button @click="disDel2 = false">取 消</el-button>
  	<el-button type="primary" @click="doDel2()">确 定</el-button>
    </span>
  </el-dialog>
  <el-dialog
    title="修改"
    :visible.sync="disDialogVisible"
    width="30%"
    center>
    <input type="text" class="searchT" style="height: 30px;width: 600px;" v-model="n"/>
    <span slot="footer" class="dialog-footer">
  	<el-button @click="disDialogVisible = false">取 消</el-button>
  	<el-button type="primary" @click="dodisChange()">确 定</el-button>
    </span>
  </el-dialog>
  </el-container>
</template>

<script>

  export default {
    data() {
      return {
        list:[],
        list2:[],
        yid:0,
        appid1:'',
        appid2:'',
        urls:'',
        content:'无',
        name:'未选择',
        disDel1:false,
        delid1:0,
        disDel2:false,
        disDel2:false,
        delid2:0,
        ts:0,
        t:0,
        n:'',
        cid:0,
        disDialogVisible:false,
        url:this.$store.getters.getUrl
      };
    },
	directives: {

    },
    created() {

      this.loadData();

    },

	methods:{
    change(id,n,t,ts){
      this.cid = id
      this.n = n
      this.t = t
      this.ts = ts
      this.disDialogVisible = true
    },
    dodisChange(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
      		id:this.cid,
          n:this.n,
          t:this.t,
          ts:this.ts
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/yzkjlistchange'
      })
      .then(res=>{
        if(this.ts == 1){
          if(this.t == 1 ){
            this.name = this.n
          }
          this.loadData();
        }else{
          this.loadDataTwo();
        }
      	this.cid = 0
        this.n = ''
        this.t = 0
        this.ts = 0
        this.disDialogVisible = false

      })
      .catch(err=>{

      });
    },
    del1(id){
      this.disDel1 = true
      this.delid1 = id
    },
    del2(id){
      this.disDel2 = true
      this.delid2 = id
    },

    doDel1(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
      		id:this.delid1,
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/yzkjlistdel1'
      })
      .then(res=>{
        this.delid1 = 0
        this.disDel1 = false
      	this.loadData();

      })
      .catch(err=>{

      });
    },
    doDel2(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
      		id:this.delid2,
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/yzkjlistdel2'
      })
      .then(res=>{
        this.delid2 = 0
        this.disDel2 = false
      	this.loadDataTwo();

      })
      .catch(err=>{

      });
    },
		loadData(){
			const axiosInstance = this.$axios.create({
				headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
				withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
			});
			axiosInstance({
				method:'get',
				params:{

				},
				url:'http://y31p.yoooooo.com/index.php/index/data/gyzkjlist1'
			})
			.then(res=>{
				this.list = res.data.data;

			})
			.catch(err=>{

			});
		},
		loadDataTwo(){
			const axiosInstance = this.$axios.create({
				headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
				withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
			});
			axiosInstance({
				method:'get',
				params:{
					id:this.yid
				},
				url:'http://y31p.yoooooo.com/index.php/index/data/gyzkjlist2'
			})
			.then(res=>{
				this.list2 = res.data.data;

			})
			.catch(err=>{

			});
		},
		chose(id,name){
			this.yid = id;
      this.name = name
			this.loadDataTwo();

		},

		add1(){
			if(this.appid1 == ''){
				this.msg('请填写空间模块APPID','error')
				return false;
			}
      if(this.urls == ''){
      	this.msg('请填写空间模块链接','error')
      	return false;
      }
			const axiosInstance = this.$axios.create({
				headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
				withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
			});
			axiosInstance({
				method:'post',
				params:{
					appid:this.appid1,
					url:this.urls,

				},
				url:'http://y31p.yoooooo.com/index.php/index/data/yzkjlistadd1'
			})
			.then(res=>{
        this.loadData();

			})
			.catch(err=>{

			});

		},
    add2(){
      if(this.yid == 0){
      	this.msg('请选择主项','error')
      	return false;
      }
    	if(this.appid2 == ''){
    		this.msg('请填写APPID','error')
    		return false;
    	}

    	const axiosInstance = this.$axios.create({
    		headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
    		withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
    	});
    	axiosInstance({
    		method:'post',
    		params:{
    			appid:this.appid2,
    			content:this.content,
          yid:this.yid
    		},
    		url:'http://y31p.yoooooo.com/index.php/index/data/yzkjlistadd2'
    	})
    	.then(res=>{
        this.appid2 = ''
        this.content = '无'
        this.loadDataTwo();

    	})
    	.catch(err=>{

    	});

    },
    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },
	}


  }
</script>

<style>

	.content{
		background: #939AA0;
		width: 100%;
		height: 100%;
	}
	.centr{
		margin-top: 30%;
	}
	.centr img{
		width: 100px;
		height: 50px;
		margin-left: 35px;
	}

	.zhuyi{
		color: red;
    margin-left: 120px;
    font-size: 20px;
	}
	.butn{
		color: #F0F8FF;
		background: #FF9400;
		margin-right: 20px;
		border-radius: 5px;
		width: 50px;
	}
	.lables{
		margin-left: 5%;
		margin-right: 5%;
		background: #fff;
		padding-bottom: 35px;
	}
	.lables .la-list1{
		margin-top: 50px;
		width: 100%;
		margin-left: 4%;
		margin-right: 4%;
	}
	.first{
		border: 1px solid #c6c6c6;
		height: 850px;
		overflow-y:scroll;
	}
	.first .el-row{
		margin: 20px 10% 20px 10%;
	}
	.search input{
		width: 95%;
		height: 20px;
		margin-bottom: 10px;
		margin-left: 2%;
	}
	.add{
		text-align: center;
		width: 96%;
		background: #c6c6c6;
		height: 22px;
		line-height: 22px;
		margin-left: 2%;
	}

	.lable-o{
		width: 47%;
		text-align: center;
		background: #c6c6c6;
		height: 30px;
		line-height: 30px;
		margin-bottom: 10px;
	}
	.lable-two{

		text-align: center;
		background: #c6c6c6;

		line-height: 30px;
		margin-bottom: 10px;
	}
	.choses{
		background: #f8f1da;
	}
	.chosess{
		background: #ff9400;
	}
	.right{
		float: right;
	}
	.left{
		float: left;
	}
	.two{
		border: 1px solid #c6c6c6;
		height: 850px;
		overflow-y:scroll;
	}
	.two .el-row{
		margin: 20px 10% 20px 10%;
	}
	.searchTsxk{
		width: 20%;
		/* margin-left: 10%; */
		height: 30px;
	}
	.searchTsxkk{
		width: 20%;
		margin-left: 2%;
		height: 30px;
	}
  .s_or_x{
    width: 20%;
    height: 35px;
  }
	.lable-o-ls{
		border-bottom: 1px solid #c6c6c6;
	}
</style>



// WEBPACK FOOTER //
// src/components/main/yzkjshipei.vue